<template>
<div>

  <!-- <div class="row" v-if="token.role !== 'ADM'">
    <div class="col">
      <p class="text-center">
        <img  style="width: 200px;" src="/static/logo.webp" alt="CAQUI Logo">
      </p>
    </div>
  </div> -->

  <div class="row" v-if="token.role === 'ADM'">
    <div class="col">
      DASHBOARD ADMIN
    </div>
  </div>

  <div class="row justify-content-md-center" v-if="token.role !== 'ADM'">
    <div class="col-12 mb-2 mt-4"
    v-if="token.empresaModel.modulos.compromissos"
    >
      <router-link tag="div" to="/compromissos" class="mx-auto col-12 col-md-6">
        <div class="card text-center bg-success">
          <div class="card-body">
            <i class="material-icons icone">assignment_turned_in</i>
            <p class="card-text">Documentos Ambientais</p>
            <small>(Licenças, Outorgas, etc)</small>
          </div>
        </div>
      </router-link>
    </div>

    <div class="col-12 mb-2 mt-4"
    v-if="token.empresaModel.modulos.condicionantes"
    >
      <router-link tag="div" to="/condicionantes" class="mx-auto col-12 col-md-6">
        <div class="card text-center bg-success">
          <div class="card-body">
            <i class="material-icons icone">swap_horizontal_circle</i>
            <p class="card-text">Condicionantes</p>
          </div>
        </div>
      </router-link>
    </div>

    <div class="col-12 mb-2 mt-4"
    v-if="token.empresaModel.modulos.renovacao"
    >
      <router-link tag="div" to="/renovacao" class="mx-auto col-12 col-md-6">
        <div class="card text-center bg-success">
          <div class="card-body">
            <i class="material-icons icone">autorenew</i>
            <p class="card-text">Renovações em andamento</p>
          </div>
        </div>
      </router-link>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: 'Dashboard',
  beforeMount() {
    if (this.token.role === 'ADM') {
      this.$router.push('/admin');
    }
  }
};
</script>

<style scoped>
.icone {
  font-size: 50px;
  color: white;
  width: 50px;
  overflow: hidden;
}

.card {
  color: white;
  font-size: 12pt;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/app/home/Home.vue